// extracted by mini-css-extract-plugin
export default {"estado":"solicitudesPJ-form_estado__B9Rtu"};